import React from 'react';
import isNil from 'lodash/isNil';
import { format } from 'date-fns';

export const getReadOnlyDate = (date) => (date ? format(date, 'MM/DD/YYYY') : '');

/**
 * A read only date component.
 *
 * @typedef {Object} ReadOnlyDateProps
 * @property {Date} [value] The date value.
 *
 * @param {React.HTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & ReadOnlyDateProps} props Component props.
 * @returns {React.ReactElement} Read only date component.
 */
const ReadOnlyDate = (props) => {
  const { value } = props;

  if (isNil(value)) {
    return (
      <div className="read-only empty" {...props}>
        Not set
      </div>
    );
  }

  return (
    <div className="read-only" {...props}>
      {getReadOnlyDate(value)}
    </div>
  );
};

export default ReadOnlyDate;
